import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=unauth

  useEffect(() => {
    if (sessionStorage.getItem("roleViewEnded")) {
      sessionStorage.removeItem("roleViewEnded");
      toast.info("De rolweergave is verlopen. Je bent terug in je eigen rol.");
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    sessionStorage.removeItem("roleSession");
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("token");
    sessionStorage.removeItem("roleSession");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const switchRole = async (role) => {
    const { data } = await api.post("/auth/view-role", { role });
    if (data.role_session) sessionStorage.setItem("roleSession", data.role_session);
    else sessionStorage.removeItem("roleSession");
    // Remount the entire page so data from the previous role cannot linger.
    window.location.assign(role === "volunteer" ? "/dashboard" : "/planner");
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refreshUser, switchRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
